// extracted by mini-css-extract-plugin
export var container = "_4l-0";
export var containerTopRight = "_4l-1";